import React from "react";
import {Checkout} from "depoto-core";
import {useNavigate} from "react-router";
import './CheckoutTile.css'
import {useCore} from "../hooks";
import {CheckoutTileDetail} from "./CheckoutTileDetail.tsx";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

type Props = {
  checkout: Checkout
}
export const CheckoutTile: React.FC<Props> = ({ checkout }) => {
  const { setSelectedCheckoutId } = useCore()
  const navigate = useNavigate()

  const isOpen = checkout.currentClosing?.dateOpen && !checkout.currentClosing?.dateClosed

  const openCheckout = () => {
    if (isOpen) {
      setSelectedCheckoutId(checkout.id)
      navigate('/dashboard')
    } else {
      navigate(`/checkout-open/${checkout.id}`)
    }
  }

  return (
    <div className="checkout-tile border border-base-300 rounded-md cursor-pointer  bg-white" onClick={openCheckout}>
      <div className="flex flex-row justify-between border-b border-base-300 p-4">
        <div className="font-semibold text-base-400 text-base"><FontAwesomeIcon icon={['far', 'cash-register']} className="mr-2 text-primary" /> {checkout.name}</div>
        <div>
          <div className={isOpen ? 'text-success' : 'text-error'}>{isOpen ? 'Otevřená pokladna' : 'Uzavřená pokladna'}</div>
        </div>
      </div>
      <CheckoutTileDetail checkout={checkout} isOpen={isOpen} />
    </div>
  )
}
